import { defaultContextValues, IAction, IState } from './useNewUserContext';

export type ActionTypes =
  | 'CLEAR_ERROR'
  | 'CREATE_USER_SUCCESS'
  | 'CREATE_USER_FAIL'
  | 'REMOVE_BRANDS'
  | 'REMOVE_GROUPS'
  | 'REMOVE_SITES'
  | 'RESET_WIZARD'
  | 'UPDATE_BRANDS'
  | 'UPDATE_GROUPS'
  | 'UPDATE_SITES'
  | 'UPDATE_STEP_VALID'
  | 'UPDATE_ROLES'
  | 'SET_SELECTED_ACCESS_LEVEL'
  | 'SET_SELECTED_MULTISITE_VALUE'
  | 'SET_SELECTED_GROUP_VALUE'
  | 'SET_SELECTED_BRAND_VALUE'
  | 'SET_SELECTED_SITE_VALUE'
  | 'SET_SELECTED_ROLE_VALUE'
  | 'UPDATE_USER_EMAIL'
  | 'UPDATE_USER_NAME'
  | 'UPDATE_VALID_STEPS';

export function newUserReducer(state: IState, action: IAction) {
  const { payload } = action;
  let newState: IState = null;

  switch (action.type) {
    case 'CREATE_USER_FAIL':
    case 'CREATE_USER_SUCCESS':
      newState = {
        ...state,
        success: payload.success,
        createdUser: payload.createdUser,
        error: payload.error,
        errorMessage: payload.errorMessage,
      };
      break;
    case 'RESET_WIZARD':
      newState = { ...defaultContextValues };
      break;
    case 'UPDATE_ROLES':
      newState = {
        ...state,
        roles: payload.roles,
      };
      break;
    case 'CLEAR_ERROR':
      newState = {
        ...state,
        error: false,
      };
      break;
    case 'UPDATE_GROUPS':
      newState = {
        ...state,
        groups: payload.groups,
      };
      break;
    case 'REMOVE_GROUPS':
      newState = {
        ...state,
        groups: [],
      };
      break;
    case 'UPDATE_BRANDS':
      newState = {
        ...state,
        brands: payload.brands,
      };
      break;
    case 'REMOVE_BRANDS':
      newState = {
        ...state,
        brands: [],
      };
      break;
    case 'UPDATE_SITES':
      newState = {
        ...state,
        sites: payload.sites,
      };
      break;
    case 'REMOVE_SITES':
      newState = {
        ...state,
        sites: [],
      };
      break;
    case 'UPDATE_USER_NAME':
      newState = {
        ...state,
        user: {
          ...state.user,
          name: payload.name,
        },
      };
      break;

    case 'UPDATE_USER_EMAIL':
      newState = {
        ...state,
        user: {
          ...state.user,
          email: payload.email,
        },
      };
      break;

    case 'SET_SELECTED_ROLE_VALUE':
      newState = {
        ...state,
        user: {
          ...state.user,
          selectedRole: payload.selectedRole,
          rolePermissions: payload.rolePermissions,
        },
      };
      break;

    case 'SET_SELECTED_ACCESS_LEVEL':
      newState = {
        ...state,
        user: {
          ...state.user,
          selectedAccessLevel: payload.selectedAccessLevel,
        },
      };
      break;

    case 'SET_SELECTED_GROUP_VALUE':
      newState = {
        ...state,
        user: {
          ...state.user,
          selectedMultiSiteGroup: payload.selectedMultiSiteGroup,
          selectedMultiSites: [],
        },
      };
      break;

    case 'SET_SELECTED_BRAND_VALUE':
      newState = {
        ...state,
        user: {
          ...state.user,
          selectedBrand: payload.selectedBrand,
        },
      };
      break;

    case 'SET_SELECTED_SITE_VALUE':
      newState = {
        ...state,
        user: {
          ...state.user,
          selectedSite: payload.selectedSite,
        },
      };
      break;

    case 'SET_SELECTED_MULTISITE_VALUE':
      newState = {
        ...state,
        user: {
          ...state.user,
          selectedMultiSites: payload.selectedMultiSites,
        },
      };
      break;

    case 'UPDATE_STEP_VALID':
      newState = {
        ...state,
        stepValid: payload.stepValid,
      };
      break;

    case 'UPDATE_VALID_STEPS':
      newState = {
        ...state,
        validSteps: payload.validSteps,
      };
      break;

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }

  return newState;
}
